import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/styles/globals.css'
import '@/styles/pages.css'
import App from './App'

const root = document.getElementById('root')

if (!root) {
  throw new Error('Root element not found. Check that index.html has <div id="root"></div>')
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
)
